import actionTypes from '../webActionTypes';
import GLOBAL from '../../jcolorglobal';

const API_URL = '/InvoiceAction.do';


function beginCreateInvoice(payload) {
    return { type: actionTypes.beginCreateInvoice, payload };
}

function recvCreateInvoiceError(payload) {
    return { type: actionTypes.recvCreateInvoiceError, payload };
}


function recvCreateInvoiceResult(payload) {
    return { type: actionTypes.recvCreateInvoiceResult, payload };
}


function createInvoice(payload = {}) {
    return dispatch => {

        dispatch(beginCreateInvoice(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'createInvoice');
            formData.append('settleType', 2);
            formData.append('createInvoiceForm', JSON.stringify(payload));
             

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(recvCreateInvoiceResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvCreateInvoiceError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvCreateInvoiceError(error));
                    reject(error);
                });
        });

        return promise;

    };
}


function beginFailInvoice(payload) {
    return { type: actionTypes.beginFailInvoice, payload };
}

function recvFailInvoiceError(payload) {
    return { type: actionTypes.recvFailInvoiceError, payload };
}


function recvFailInvoiceResult(payload) {
    return { type: actionTypes.recvFailInvoiceResult, payload };
}


function failInvoice(payload = {}) {
    return dispatch => {

        dispatch(beginFailInvoice(payload)); // dispatch synced action to Fail loading status

        const promise = new Promise((resolve, reject) => {
            
            const formData = new FormData();
            formData.append('op', 'failInvoice');
            formData.append('yearmonth', payload.yearmonth);
            formData.append('invoiceType', payload.invoicetype);
            formData.append('istarttag', payload.istarttag);
            formData.append('invoiceNumber', payload.invoicenumber);


            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    if(result.error) {
                        reject(result.error);
                        return 
                    }

                    dispatch(recvFailInvoiceResult(payload));
                    resolve(result);
                }).catch(error => {
                    dispatch(recvFailInvoiceError(error));
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                dispatch(recvFailInvoiceError(error));
                reject(error);
            });
        });

        return promise;

    };
}

function beginGetInvoiceList(payload) {
    return { type: actionTypes.beginGetInvoiceList, payload };
}

function recvGetInvoiceListError(payload) {
    return { type: actionTypes.recvGetInvoiceListError, payload };
}


function recvGetInvoiceListResult(payload) {
    return { type: actionTypes.recvGetInvoiceListResult, payload };
}


function getInvoiceList(payload = {}) {
    return (dispatch, getState) => {

        dispatch(beginGetInvoiceList(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            const start = payload.start || 0;
            var querykey = '';
            formData.append('op', 'getInvoiceList');

            if(payload.yearmonth) {
                formData.append('yearmonth', payload.yearmonth);
                querykey += payload.yearmonth;
            }

            if(payload.failstatus) {
                formData.append('failstatus', payload.failstatus);
                querykey += payload.failstatus;
            }

            if(payload.senddonatestatus) {
                formData.append('senddonatestatus', payload.senddonatestatus);
                querykey += payload.senddonatestatus;
            }

            if(payload.typeTurnkeyupcasttime) {
                formData.append('typeTurnkeyupcasttime', payload.typeTurnkeyupcasttime);
                querykey += payload.typeTurnkeyupcasttime;
            }

            if(payload.orderid) {
                formData.append('orderid', payload.orderid);
                querykey += payload.orderid;
            }

            if(payload.invoiceNumber) {
                formData.append('invoiceNumber', payload.invoiceNumber);
                querykey += payload.invoiceNumber;
            }

            if(!isNaN(payload.starttime) && payload.starttime > 0) {
                formData.append('starttime', payload.starttime);
                querykey += payload.starttime;
            }
            if(!isNaN(payload.endtime) && payload.endtime > 0) {
                formData.append('endtime', parseInt(payload.endtime, 10) + 24 * 60 * 60 * 1000 );
                querykey += payload.endtime;
            }

            formData.append('start', start);
            formData.append('len', getState().invoice.pageLen || 20);

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    if(result.error) {
                        reject(result.error);
                        return 
                    }

                    // 拆解list result成id list and data map兩組資料
                    let ids = {};
                    let data = {};
                    // eslint-disable-next-line
                    result.list.map((listitem, index) => {
                        const id = listitem.istarttag+listitem.invoicenumber;
                        ids[start+index] = id;
                        data[id] = listitem;

                    });
                    const { totalCount } = result;

                    dispatch(recvGetInvoiceListResult({ids, data, start, totalCount, querykey}));
                    resolve(result);
                })
                .catch(error => {
                    dispatch(recvGetInvoiceListError(error));
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                dispatch(recvGetInvoiceListError(error));
                reject(error);
            });
        });

        return promise;

    };
}



function beginGetInvoiceInfo(payload) {
    return { type: actionTypes.beginGetInvoiceInfo, payload };
}

function recvGetInvoiceInfoError(payload) {
    return { type: actionTypes.recvGetInvoiceInfoError, payload };
}


function recvGetInvoiceInfoResult(payload) {
    return { type: actionTypes.recvGetInvoiceInfoResult, payload };
}


function getInvoiceInfo(payload = {}) {
    return (dispatch, getState) => {

        dispatch(beginGetInvoiceInfo(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'getInvoiceInfo');
            formData.append('yearmonth', payload.yearmonth);
            formData.append('istarttag', payload.istarttag);
            formData.append('invoiceNumber', payload.invoicenumber);
            
            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                    
                            dispatch(recvGetInvoiceInfoResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvGetInvoiceInfoError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvGetInvoiceInfoError(error));
                    reject(error);
                });
        });

        return promise;

    };
}



function beginUpdateInvoice(payload) {
    return { type: actionTypes.beginUpdateInvoice, payload };
}

function recvUpdateInvoiceError(payload) {
    return { type: actionTypes.recvUpdateInvoiceError, payload };
}


function recvUpdateInvoiceResult(payload) {
    return { type: actionTypes.recvUpdateInvoiceResult, payload };
}


function updateInvoice(payload = {}) {
    return dispatch => {

        dispatch(beginUpdateInvoice(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'updateInvoiceItem');
            formData.append('yearmonth', payload.yearmonth);
            formData.append('istarttag', payload.istarttag);
            formData.append('invoiceNumber', payload.invoiceNumber);
            formData.append('createInvoiceForm', JSON.stringify(payload));
             

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(recvUpdateInvoiceResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvUpdateInvoiceError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvUpdateInvoiceError(error));
                    reject(error);
                });
        });

        return promise;

    };
}



function beginGetOrderInvoiceInfo(payload) {
    return { type: actionTypes.beginGetOrderInvoiceInfo, payload };
}

function recvGetOrderInvoiceInfoError(payload) {
    return { type: actionTypes.recvGetOrderInvoiceInfoError, payload };
}


function recvGetOrderInvoiceInfoResult(payload) {
    return { type: actionTypes.recvGetOrderInvoiceInfoResult, payload };
}


function getOrderInvoiceInfo(payload = {}) {
    return (dispatch, getState) => {

        dispatch(beginGetOrderInvoiceInfo(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'getInvoiceInfoByOrderID');
            formData.append('orderid', payload.orderid);
            
            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                    
                            dispatch(recvGetOrderInvoiceInfoResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvGetOrderInvoiceInfoError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvGetOrderInvoiceInfoError(error));
                    reject(error);
                });
        });

        return promise;
    };
}


// ------------------------------
// 開啟下載發票媒體申報檔Dialog
// ------------------------------
function openDownloadTaxMediaDialog(payload) {

    return { type: actionTypes.openDownloadTaxMediaDialog, payload };
}

// ------------------------------
// 關閉下載發票媒體申報檔Dialog
// ------------------------------
function closeDownloadTaxMediaDialog(payload) {

    return { type: actionTypes.closeDownloadTaxMediaDialog, payload };
}


// ------------------------------
// 下載發票報表
// ------------------------------
function dnldInvoiceReport(starttime, endtime) {

    return function(dispatch, getState) {

        var url = API_URL + '?op=dnldInvoiceReport';

        if (starttime && starttime > 0) {
            url = url + '&starttime=' + starttime;
        }

        if (endtime && endtime > 0) {
            var _endtime = parseInt(endtime, 10) + 24 * 60 * 60 * 1000
            url = url + '&endtime=' + _endtime;
        }

        return url;
    }
}

// ------------------------------
// 下載發票媒體申報檔1
// ------------------------------
function dnldInvoiceTaxMedia1(starttime, endtime) {

    return function(dispatch, getState) {

        var url = API_URL + '?op=dnldInvoiceTaxMedia1';

        if (starttime && starttime > 0) {
            url = url + '&starttime=' + starttime;
        }

        if (endtime && endtime > 0) {
            var _endtime = parseInt(endtime, 10) + 24 * 60 * 60 * 1000
            url = url + '&endtime=' + _endtime;
        }

        return url;
    }
}

// ------------------------------
// 下載發票媒體申報檔2
// ------------------------------
function dnldInvoiceTaxMedia2(starttime, endtime) {

    return function(dispatch, getState) {

        var url = API_URL + '?op=dnldInvoiceTaxMedia2';

        if (starttime && starttime > 0) {
            url = url + '&starttime=' + starttime;
        }

        if (endtime && endtime > 0) {
            var _endtime = parseInt(endtime, 10) + 24 * 60 * 60 * 1000
            url = url + '&endtime=' + _endtime;
        }

        return url;
    }
}

// ------------------------------
// 更新發票狀態
// ------------------------------
function updateInvoiceStatus(payload = {}) {

    const {
        yearmonth,
        istarttag,
        invoiceNumber,
        istatus,
    } = payload;

    return dispatch => {
        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'updateInvoiceStatus');
            formData.append('yearmonth', yearmonth);
            formData.append('istarttag', istarttag);
            formData.append('invoiceNumber', invoiceNumber);
            formData.append('istatus', istatus);

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    if(result.error) {
                        reject(result.error);
                        return 
                    }

                    dispatch(finishUpdateInvoiceStatus({
                        yearmonth: yearmonth,
                        istarttag: istarttag,
                        invoiceNumber: invoiceNumber,
                        istatus: istatus,
                    }));

                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                reject(error);
            });
        });

        return promise;
    };
}

function finishUpdateInvoiceStatus(payload) {

    return { type: actionTypes.finishUpdateInvoiceStatus, payload };
}

function getInvoiceItemYearmonthList() {
    return (dispatch, getState) => {

        const promise = new Promise((resolve, reject) => {

            const url = API_URL + '?op=getInvoiceItemYearmonthList';

            GLOBAL.fetchWithCookies(url, {
                method: 'GET',
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    dispatch(finishGetInvoiceItemYearmonthList(result));
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                reject(error);
            });
        });

        return promise;
    };
}

function finishGetInvoiceItemYearmonthList(yearmonthList) {

    return { type: actionTypes.finishGetInvoiceItemYearmonthList, payload: { yearmonthList: yearmonthList } };
}

// ------------------------------
// 重新上傳發票pdf至s3
// ------------------------------
function reUploadInvoicePdf(payload) {

    return (dispatch, getState) => {
        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'reUploadInvoicePdf');
            formData.append('yearmonth', payload.yearmonth);
            formData.append('istarttag', payload.istarttag);
            formData.append('invoiceNumber', payload.invoicenumber);

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            }).then(response => {

                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    if(result.error) {
                        reject(result.error);
                        return 
                    }

                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                reject(error);
            });
        });

        return promise;
    }
}

const invoiceActions = {
    beginCreateInvoice,
    recvCreateInvoiceError,
    recvCreateInvoiceResult,
    createInvoice,
    beginFailInvoice,
    recvFailInvoiceError,
    recvFailInvoiceResult,
    failInvoice,
    beginGetInvoiceList,
    recvGetInvoiceListError,
    recvGetInvoiceListResult,
    getInvoiceList,
    beginGetInvoiceInfo,
    recvGetInvoiceInfoError,
    recvGetInvoiceInfoResult,
    getInvoiceInfo,
    beginUpdateInvoice,
    recvUpdateInvoiceError,
    recvUpdateInvoiceResult,
    updateInvoice,
    beginGetOrderInvoiceInfo,
    recvGetOrderInvoiceInfoError,
    recvGetOrderInvoiceInfoResult,
    getOrderInvoiceInfo,
    openDownloadTaxMediaDialog,
    closeDownloadTaxMediaDialog,
    dnldInvoiceTaxMedia1,
    dnldInvoiceTaxMedia2,
    updateInvoiceStatus,
    getInvoiceItemYearmonthList,
    dnldInvoiceReport,
    reUploadInvoicePdf,
};

export default invoiceActions;


// WEBPACK FOOTER //
// ./src/actions/creators/invoiceActions.js